export const isInitialDataLoaded = (ctx) =>
  ctx.budgetPlanLoaded && ctx.budgetCategoriesLoaded;

export const isPlanNotFound = (ctx) => ctx.budgetPlan?.notFound;

export const isPlanCreated = (ctx) => !!ctx.budgetPlan?.id;

export const hasCurrentBudgetCategory = (ctx) =>
  !!ctx.budgetPlan?.currentBudgetCategory?.code;

export const isBudgetComplete = (ctx) => {
  const numSlides = ctx.slideConfigs?.length ?? 0;
  return (ctx.budgetPlan?.options?.length ?? 0) >= numSlides;
};

/**
 * Calculates the new slide index based on the current context and navigation event.
 * @param {Object} ctx - The current context
 * @param {Object} event - The navigation event with direction or slideIndex
 * @returns {number} The calculated new slide index
 */
export const calculateNewSlideIndex = (ctx, { direction, slideIndex }) => {
  if (slideIndex !== undefined) {
    return slideIndex;
  }

  if (direction === "next") {
    return Math.min(ctx.currentSlideIndex + 1, ctx.totalSlides - 1);
  }

  if (direction === "previous") {
    return Math.max(ctx.currentSlideIndex - 1, 0);
  }

  return ctx.currentSlideIndex;
};

export const isNavigatingToFirstSlide = (ctx, event) => {
  return calculateNewSlideIndex(ctx, event) === 0;
};

export const isNavigatingToLastSlide = (ctx, event) => {
  return calculateNewSlideIndex(ctx, event) === ctx.totalSlides - 1;
};
